function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.9977 9.1C10.0477 9.1 11.7227 7.425 11.7227 5.375C11.7227 3.325 10.0477 1.625 7.9977 1.625C5.9477 1.625 4.27271 3.3 4.27271 5.35C4.27271 7.4 5.9477 9.1 7.9977 9.1ZM7.9977 2.5C9.5727 2.5 10.8477 3.775 10.8477 5.35C10.8477 6.925 9.5727 8.2 7.9977 8.2C6.4227 8.2 5.14771 6.925 5.14771 5.35C5.14771 3.8 6.4227 2.5 7.9977 2.5Z",
  fill: "#323F4B"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5227 13.5999C13.4477 11.8249 10.7727 10.8499 7.99769 10.8499C5.22269 10.8499 2.54769 11.8249 0.472692 13.5999C0.272692 13.7499 0.247692 14.0249 0.422692 14.2249C0.572692 14.3999 0.847692 14.4249 1.04769 14.2749C2.97269 12.6499 5.44769 11.7499 8.02269 11.7499C10.5977 11.7499 13.0727 12.6499 14.9977 14.2749C15.0727 14.3499 15.1727 14.3749 15.2727 14.3749C15.3977 14.3749 15.5227 14.3249 15.5977 14.2249C15.7477 14.0249 15.7227 13.7499 15.5227 13.5999Z",
  fill: "#323F4B"
});
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.aea7d8431642c7a7207e4322ecde1127.svg";
export { ForwardRef as ReactComponent };